export const Hero = {
  mode: "string",
  height: "unit(px,%)",
  "background-url": "string",
  "background-width": "unit(px,%)",
  "background-height": "unit(px,%)",
  "background-position": "string",
  "border-radius": "string",
  "container-background-color": "color",
  "inner-background-color": "color",
  "inner-padding": "unit(px,%){1,4}",
  "inner-padding-top": "unit(px,%)",
  "inner-padding-left": "unit(px,%)",
  "inner-padding-right": "unit(px,%)",
  "inner-padding-bottom": "unit(px,%)",
  padding: "unit(px,%){1,4}",
  "padding-bottom": "unit(px,%)",
  "padding-left": "unit(px,%)",
  "padding-right": "unit(px,%)",
  "padding-top": "unit(px,%)",
  "background-color": "color",
  "vertical-align": "enum(top,bottom,middle)",
};
